"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkEntityStrategy = linkEntityStrategy;
exports.getRichTextEditorContentMediator = getRichTextEditorContentMediator;

var _immutable = require("immutable");

var _translate = _interopRequireDefault(require("transmute/translate"));

var _draftConvert = require("draft-convert");

var _RichTextEditorContentMediator = _interopRequireDefault(require("./RichTextEditorContentMediator"));

var richTextEditorConfigurationTranslation = {
  config: function config(rteConfiguration) {
    return rteConfiguration.composed;
  },
  toHtml: function toHtml(rteConfiguration) {
    return rteConfiguration.composed(_draftConvert.convertToHTML);
  },
  fromHtml: function fromHtml(rteConfiguration) {
    return rteConfiguration.composed(_draftConvert.convertFromHTML);
  },
  hasContent: true
};

var toRichTextEditorContentMediator = function toRichTextEditorContentMediator(rteConfiguration) {
  return new _RichTextEditorContentMediator.default((0, _translate.default)(richTextEditorConfigurationTranslation, rteConfiguration));
};

var contentMediators = (0, _immutable.Map)();

function linkEntityStrategy(Entity) {
  return function (contentBlock, callback, contentState) {
    contentBlock.findEntityRanges(function (character) {
      var entityKey = character.getEntity();
      var getEntity = contentState.getEntity || Entity.get;
      return entityKey !== null && getEntity(entityKey).getType() === 'LINK';
    }, callback);
  };
}

function getRichTextEditorContentMediator(richTextEditorConfiguration) {
  var type = richTextEditorConfiguration.type;

  if (!contentMediators.has(type)) {
    var contentMediator = toRichTextEditorContentMediator(richTextEditorConfiguration);
    contentMediators = contentMediators.set(type, contentMediator);
  }

  return contentMediators.get(type);
}